import * as Yup from "yup";
import { MarketingOptions } from "../types/MarketingOptions";

export const marketingOptionsSchema = Yup.object<MarketingOptions>().shape({
    enabled: Yup.boolean(),
    prompt: Yup.boolean(),
});
